import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import { Link } from "react-router-dom";
import { dateTimeFormat } from "../../../util/DateUtil";
import { currencyBRL } from "../../../util/DoubleUtil";

const CantinaSaldoViewInsereCredito = ({ cantinaSaldo, podeInserirCredito }) => {
  const valor = Number(cantinaSaldo?.valorSaldo ?? 0);

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
        <Box
          sx={{
            display: "flex",
            p: 1.5,
            borderRadius: 2,
            bgcolor: "action.hover",
            color: "primary.main",
            alignSelf: "flex-start",
          }}
        >
          <AccountBalanceWalletOutlinedIcon fontSize="large" />
        </Box>
        <Box flexGrow={1}>
          <Typography variant="body2" color="text.secondary">
            Saldo disponível
          </Typography>
          <Typography variant="h4" fontWeight={600} color={valor < 0 ? "error.main" : "text.primary"}>
            {currencyBRL(valor)}
          </Typography>
          {cantinaSaldo?.dataHoraUltimaAtualizacao && (
            <Typography variant="caption" color="text.secondary">
              Atualizado em {dateTimeFormat(cantinaSaldo.dataHoraUltimaAtualizacao)}
            </Typography>
          )}
        </Box>
        {podeInserirCredito && (
          <Button
            variant="contained"
            startIcon={<AddCardOutlinedIcon />}
            component={Link}
            to="/cantina/insere-credito"
            sx={{ alignSelf: { xs: "stretch", sm: "center" } }}
          >
            Inserir Crédito
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default CantinaSaldoViewInsereCredito;
